import { render, staticRenderFns } from "./masterBasicTabUICustomLayout.vue?vue&type=template&id=7df15017&"
import script from "./masterBasicTabUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./masterBasicTabUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7df15017')) {
      api.createRecord('7df15017', component.options)
    } else {
      api.reload('7df15017', component.options)
    }
    module.hot.accept("./masterBasicTabUICustomLayout.vue?vue&type=template&id=7df15017&", function () {
      api.rerender('7df15017', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTabUICustomLayout.vue"
export default component.exports